import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import {
  BaseForm,
  BaseButton,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseInput
} from 'xrk-components';
import {
  getEnterpriseCupBankInfo,
  saveEnterpriseCupBankInfo
} from '../data-source/apis';
import { GetEnterpriseCupBankInfoData } from '../data-source/types';
import { BaseTextContent } from 'xrk-components';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-online-config-dialog',
  props: {
    remove: {},
    deptId: {},
    entpName: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const formRef = ref();
const formData = ref<GetEnterpriseCupBankInfoData>({
  deptId: props.deptId,
  companyName: props.entpName,
  cupBankId: null,
  bankName: '',
  bankNumber: '',
  companyCardNo: ''
});

const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  await formRef.value.validate();
  await saveEnterpriseCupBankInfo(formData.value);
  XrkMessage.success('操作成功');
  emits('success');
  onCancel();
};

onMounted(async () => {
  const { data } = await getEnterpriseCupBankInfo({
    deptId: props.deptId
  });
  Object.assign(formData.value, data ?? {});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "450px",
    title: "网银支付结算单支付信息配置",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        click: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), { style: {"height":"446px"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "right",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "单位名称",
                prop: "companyName",
                rules: [
            {
              required: true,
              message: '请输入单位名称',
              trigger: 'change'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "text",
                    placeholder: "请输入",
                    disabled: "",
                    modelValue: formData.value.companyName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.companyName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "开户银行",
                prop: "bankName",
                rules: [
            {
              required: true,
              message: '请输入开户银行',
              trigger: 'change'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "text",
                    placeholder: "请输入",
                    "max-length": "30",
                    modelValue: formData.value.bankName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.bankName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "银行账号",
                prop: "bankNumber",
                rules: [
            {
              required: true,
              message: '请输入银行账号',
              trigger: 'change'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "text",
                    placeholder: "请输入",
                    "max-length": "30",
                    modelValue: formData.value.bankNumber,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.bankNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})